export default __webpack_public_path__ + "fr/static/media/connected-account.5efcf101.svg";